import Store from '../stores/Store';
import { BASE_URL } from '../constants/api';
import { Emit, RefreshSession } from '../components/socket';

import { GlobalState } from '../states/global-state';
import { route } from 'preact-router';
import { isFalsy, showAlert, showAutoCloseAlert } from '../utils';

const Fetch = async <TData>(url, conf, negativeStatus?): Promise<TData> => {
  try {
    const csrf = await getCsrf();

    RefreshSession(response => '');

    conf.headers = {
      ...(conf.headers || {}),
      'x-csrf': csrf,
    };

    const response = await fetch(url, {
      ...conf,
      credentials: 'include',
    });
    if (response.status == 401) {
      await showAutoCloseAlert({
        html: 'You will be logged out in <b></b> milliseconds.',
        title: 'Success',
        icon: 'success',
        timer: 1500,
        timerProgressBar: true,
      }).then(() => {
        route('/logout', true);
      });

      throw new Error('logout');
    }
    const json = await response.json();

    if (json.status != undefined && json.status == 0) {
      throw new Error(json.message);
    }

    if (
      negativeStatus != undefined &&
      json.code != undefined &&
      json.code == negativeStatus
    ) {
      // throw new Error('common', { cause: {} });
      // console.log(json);
    }

    return json;
  } catch (err) {
    if (err.message == 'common') {
      showAlert({
        icon: 'error',
        title: 'Error',
        text: err.cause.info,
        allowOutsideClick: false,
      });
    } else if (err.message == 401) {
      showAlert({
        icon: 'error',
        title: 'Expired Session',
        text: 'Your session has expired, please relogin again.',
        allowOutsideClick: false,
      });

      // setTimeout(() => {
      //   route('/logout', true);
      // }, 1500);
    }
    throw new Error(err);
  }
};

export const getCsrf = async () => {
  const store = new Store();
  let csrf = store.get('x-csrf');

  if (isFalsy(csrf, 1)) {
    const response = await fetch(`${BASE_URL}/api/csrf/generate`, {
      method: 'POST',
    });
    const json = await response.json();
    if (json.status) {
      store.put('x-csrf', json['data'].csrf);
      csrf = json['data'].csrf;
    }
  }

  return csrf;
};

export default Fetch;
